import { useState, useRef, useEffect } from "react";

interface ComboFilterProps {
  placeholder: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function ComboFilter({ placeholder, options, value, onChange }: ComboFilterProps) {
  const [query, setQuery] = useState(value);
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setQuery(value);
  }, [value]);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const queryLower = query.toLowerCase();
  const filtered = query ? options.filter(o => o.toLowerCase().includes(queryLower)) : options;

  function select(val: string) {
    setQuery(val);
    onChange(val);
    setOpen(false);
  }

  function clear() {
    setQuery("");
    onChange("");
    setOpen(false);
  }

  function handleInput(val: string) {
    setQuery(val);
    setOpen(true);
    if (!val) onChange("");
  }

  return (
    <div className="combo-filter" ref={ref}>
      <input
        className="combo-filter__input"
        type="text"
        placeholder={placeholder}
        value={query}
        onChange={e => handleInput(e.target.value)}
        onFocus={() => setOpen(true)}
      />
      {value && (
        <button className="combo-filter__clear" onClick={clear} aria-label="Clear filter">
          ×
        </button>
      )}
      {open && filtered.length > 0 && (
        <ul className="combo-filter__list">
          {filtered.map(o => (
            <li
              key={o}
              className={`combo-filter__option${o === value ? " combo-filter__option--active" : ""}`}
              onMouseDown={() => select(o)}
            >
              {o}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
